// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:36:41

export default {
  "id": "money-chaser-city-parkour-game",
  "slug": "money-chaser-city-parkour-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/65983e607c9e4bec96c32c680582acdd-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/65983e607c9e4bec96c32c680582acdd/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Money Chaser- City Parkour Game",
      "description": "Chasing/Running eldnlessly for collecting coins(Money).\nTry to avoid traps & *kick out all the enemy/competitors on your way.\n*You can kick out enemy infront of you with slide skill*\n\nAfter you have enough money, you can challenge the Boss fight.\nThe amount of coins(Money Bullets) is the only weapon to defeat Boss, the more the better.\n\nRemember, no money no life...just keep running :)",
      "instructions": "For Keyboard :\n\"Space\" Key →  Jump\n\"A\" Key →  Slide or Shoot (In Boss Battle)\n\nFor Touch Screen/Mobile :\nTap Right Part of Screen  →  Jump\nTap Left Part of Screen →  Slide or Shoot (In Boss Battle)",
      "genres": [
        "Casual"
      ],
      "tags": [
        "parkour",
        "pixelart",
        "platformer"
      ]
    },
    "zh-CN": {
      "title": "金钱追逐者-城市跑酷游戏",
      "description": "追逐/奔跑无休止地收集金币（金钱）。\n尽量避开陷阱，并在路上踢出所有敌人/竞争对手。\n*你可以使用滑行技能踢出面前的敌人。\n\n在你积累足够的金钱后，你可以挑战Boss战。\n金币（金钱子弹）的数量是击败Boss的唯一武器，越多越好。\n\n记住，没有金钱就没有生命……只管一直跑吧 :)",
      "instructions": "键盘：\n“空格”键 → 跳跃\n“A”键 → 滑行或射击（在Boss战中）\n\n触屏/手机：\n点击屏幕右侧 → 跳跃\n点击屏幕左侧 → 滑行或射击（在Boss战中）",
      "genres": [
        "休闲"
      ],
      "tags": [
        "跑酷",
        "像素艺术",
        "平台游戏"
      ]
    },
    "zh-TW": {
      "title": "錢追擊 - 城市躍障遊戲",
      "description": "追逐/無盡奔跑以收集錢幣（金錢）。\n試圖避開陷阱，並在路途中踢飛所有敵人/競爭對手。\n*你可以使用滑行技能踢飛眼前的敵人*\n\n在你有足夠的金錢後，你可以挑戰Boss戰鬥。\n錢幣（金錢子彈）的數量是擊敗Boss的唯一武器，越多越好。\n\n記得，沒有金錢就沒有命...繼續奔跑吧 :)",
      "instructions": "對於鍵盤：\n\"空格鍵\" → 跳躍\n\"A\" 鍵 → 滑行或射擊（在BOSS戰中）\n\n對於觸控螢幕/行動裝置：\n點擊螢幕右邊 → 跳躍\n點擊螢幕左邊 → 滑行或射擊（在BOSS戰中）",
      "genres": [
        "隨意"
      ],
      "tags": [
        "避障賽跑",
        "像素藝術",
        "平台遊戲"
      ]
    },
    "zh-HK": {
      "title": "錢追者 - 市區疾馳遊戲",
      "description": "追逐/無止境地奔跑以收集硬幣（金錢）。\n試著避開陷阱，並將途中的所有敵人/競爭對手踢出局。\n*您可以使用滑行技能將前方的敵人踢出局*\n\n當您積攢足夠的金錢後，您可以挑戰BOSS戰鬥。\n硬幣（金錢子彈）的數量是擊敗BOSS的唯一武器，越多越好。\n\n記得，沒有金錢沒有命...只管繼續奔跑吧~",
      "instructions": "按鍵盤：\n\"空格\"按鍵 → 跳躍\n\"A\"按鍵 → 滑行或射擊（在Boss戰鬥中）\n\n觸控螢幕/手機：\n點擊螢幕右邊 → 跳躍\n點擊螢幕左邊 → 滑行或射擊（在Boss戰鬥中）",
      "genres": [
        "隨意"
      ],
      "tags": [
        "跑酷",
        "像素藝術",
        "平台遊戲"
      ]
    },
    "ja": {
      "title": "マネーチェイサー-シティパークアウトゲーム",
      "description": "コイン（お金）を集めながら追い続ける。\n罠を避け、道中の敵や競合者を排除しよう。\n*滑り技を使って前の敵を排除できる*\n\nお金が十分になるまでに挑戦しよう。\nボスバトルでは、コイン（お金弾）の数が唯一の武器であり、多いほど良い。\n\n忘れずに、お金がないと生きられない…ただ走り続けようですよ :)",
      "instructions": "キーボード：\n「スペース」キー →  跳躍\n「A」キー →  スライドまたは発射（ボスバトル時）\n\nタッチスクリーン/モバイル：\n画面の右側をタップ →  跳躍\n画面の左側をタップ →  スライドまたは発射（ボスバトル時）",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "パルクール",
        "ピクセルアート",
        "プラットフォームゲーム"
      ]
    },
    "ko": {
      "title": "금액 추격자-도시 파크로어 게임",
      "description": "코인을 모으기 위해 끝없이 추격하고 뛰는 것.\n벽돌을 피하고 *길 위의 모든 적/경쟁자를 물리치세요.\n*슬라이드 스킬로 앞에 있는 적을 밀칠 수 있습니다.*\n\n충분한 돈을 모으면 보스 전투에 도전할 수 있습니다.\n코인(머니 브렌트)의 양만이 보스를 궁극적으로 물리칠 수 있는 무기입니다, 그만큼 좋습니다.\n\n기억해요, 돈 없으면 생명이 없어... 계속 뛰세요 :)",
      "instructions": "키보드 :\n\"스페이스\" 키 → 점프\n\"A\" 키 → 슬라이드 또는 쏘기 (보스 전투 중)\n\n터치 스크린/모바일 :\n화면 오른쪽 부분 탭 → 점프\n화면 왼쪽 부분 탭 → 슬라이드 또는 쏘기 (보스 전투 중)",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "파크루어",
        "픽셀아트",
        "플랫폼 게임"
      ]
    },
    "fr": {
      "title": "Chasseur de Money - Jeu de Parkour en Ville",
      "description": "Chasser ou courir éperdument pour collecter des pièces (argent).\n Essayez d'éviter les piéges et *éliminez tous les ennemis ou concurrents sur votre chemin.\n *Vous pouvez éliminer l'ennemi en face de vous avec la compétence glisser.*\n\n Une fois que vous avez suffisamment d'argent, vous pouvez défier le combat contre le Boss.\n Le nombre de pièces (Bullets d'argent) est l'unique arme pour vaincre le Boss, plus c'est mieux.\n\n Souvenez-vous, sans argent, pas de vie...continuez simplement à courir :)",
      "instructions": "Pour le clavier :\nTouche \"Espace\" → Saut\nTouche \"A\" → Glisser ou tirer (En combat contre le boss)\n\nPour l'écran tactile ou mobile :\nAppuyer sur la partie droite de l'écran → Saut\nAppuyer sur la partie gauche de l'écran → Glisser ou tirer (En combat contre le boss)",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "parkour",
        "pixel art",
        "plate-forme"
      ]
    }
  }
};
